import { gql, useQuery } from "@apollo/client";
import { LinearProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  PositionDetailEditLoadingBoundaryQuery,
  PositionDetailEditLoadingBoundaryQueryVariables,
} from "../../__generated__/graphql";
import { useCurrencies } from "../../components/CurrenciesContext";
import { NoCompStructure } from "../../components/EmptyState/EmptyState";
import {
  assertLocationSelected,
  useLocations,
} from "../../components/LocationsContext";
import { PositionDetailEdit } from "./PositionDetailEdit";

export function PositionDetailEditLoadingBoundary(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const { selectedCurrency } = useCurrencies();
  const { selectedLocation } = useLocations();
  assertLocationSelected(selectedLocation);

  const { data, loading, error } = useQuery<
    PositionDetailEditLoadingBoundaryQuery,
    PositionDetailEditLoadingBoundaryQueryVariables
  >(PositionDetailEditLoadingBoundary.query, {
    variables: {
      positionId: Number(id),
      currencyCode: selectedCurrency.code,
      marketId: selectedLocation[0].id,
      locationGroupId: selectedLocation[1].id,
    },
  });

  if (!data || !data.position) {
    if (loading) {
      return <LinearProgress />;
    }
    if (error) {
      return <p>{JSON.stringify(error)}</p>;
    }
    return <p>Not found</p>;
  }
  if (!data.valuation) {
    return <NoCompStructure />;
  }

  return (
    <PositionDetailEdit position={data.position} valuation={data.valuation} />
  );
}

PositionDetailEditLoadingBoundary.query = gql`
  ${PositionDetailEdit.fragments.position}
  ${PositionDetailEdit.fragments.valuation}
  query PositionDetailEditLoadingBoundaryQuery(
    $positionId: Int!
    $currencyCode: CurrencyCode!
    $marketId: Int!
    $locationGroupId: Int
  ) {
    position(id: $positionId) {
      id
      ...PositionDetailEdit_position
    }
    valuation {
      id
      ...PositionDetailEdit_valuation
    }
  }
`;
